/**
 * Headern: göm vid scroll nedåt, visa vid scroll uppåt.
 *
 * Porterat från det klassiska temats Alpine-komponent `scrollData`:
 *
 *   scrollY > 50 och ingen meny/sök öppen  ->  scrollingUp = scrollY < forra
 *   scrollY > 50 och scrollingUp           ->  vit botten
 *   annars                                 ->  ingen vit botten
 *   top: scrollingUp ? 0 : -115px, transition 0.5s
 *
 * Gränsen på 50px och de 115px är originalets, inte valda på nytt.
 *
 * Utan JS står headern kvar överst med vit botten — inget göms.
 */

const HEADER = '.bk-header';
const TROSKEL = 50;
const DOLD = '-115px';

export default function headerScroll(): void {
	const header = document.querySelector< HTMLElement >( HEADER );
	if ( ! header ) {
		return;
	}

	// Skriv headerns verkliga höjd till en variabel som innehållets offset läser.
	// Ett hårdkodat tal glider isär med designen; en mätning gör det inte.
	const matHojd = () => {
		document.documentElement.style.setProperty(
			'--bk-header-h',
			Math.round( header.getBoundingClientRect().height ) + 'px'
		);
	};
	matHojd();
	window.addEventListener( 'resize', matHojd, { passive: true } );
	if ( 'fonts' in document ) {
		( document as Document & { fonts: FontFaceSet } ).fonts.ready.then( matHojd );
	}

	let forra = window.scrollY;
	let uppat = true;
	let vantar = false;

	const oppen = () =>
		!! document.querySelector(
			'.wp-block-navigation__responsive-container.is-menu-open, .bk-header__search.is-open'
		);

	const uppdatera = () => {
		vantar = false;
		const nu = window.scrollY;

		if ( nu > TROSKEL && ! oppen() ) {
			uppat = nu < forra;
			forra = nu;
		} else {
			header.classList.remove( 'is-scrolled' );
			if ( oppen() ) {
				uppat = true;
			}
		}

		if ( nu > TROSKEL && uppat ) {
			header.classList.add( 'is-scrolled' );
		}
		if ( nu <= TROSKEL ) {
			header.classList.remove( 'is-scrolled' );
			// Överst ska headern ALLTID synas. Originalet uppdaterar inte
			// riktningen i else-grenen, så ett hopp rakt till toppen kunde lämna
			// den gömd ovanför skärmkanten. Med jämn scroll märks det sällan;
			// med ankarlänkar och scrollTo(0,0) gör det det.
			uppat = true;
		}

		header.style.top = uppat ? '0' : DOLD;
	};

	window.addEventListener(
		'scroll',
		() => {
			if ( ! vantar ) {
				vantar = true;
				window.requestAnimationFrame( uppdatera );
			}
		},
		{ passive: true }
	);
}
